module.exports = __webpack_public_path__ + "img/logo.20583f2f.png";